export const HeaderENUSTranslations = {
  header4iButtonLabel: 'Navigate to home page and scroll to top',
  headerMenuButtonLabel: 'Menu button',
};
